module.exports = __webpack_public_path__ + "img/czsc_13.1bcc91f3.png";